/* Load Modules */
import React from "react";
import Footer from "../home/components/Footer/footer.component";

/* Load Components */
import Background from "../../utils/Background/Background.component";

/* Load Styles */
import "./credits.component.scss";

export default function CreditsComponentPage() {
    return (
        <div id="credits-page">
            <Background />
            <div className="page-container">
                <div>
                    <h1>Credits</h1>
                    <p>
                        Wave was created to accomplish the role of
                        centralization and interconnection of systems from
                        Fabamaq. As such, it requires the interaction with
                        multiple teams.
                    </p>

                    <h2>Contributing Teams</h2>
                    <div className="contributing-teams">
                        <div>
                            <h3>Business Solutions</h3>
                            <p>
                                Actual holder of the Wave Framework. Provider of
                                the license portal API.
                            </p>
                            <h3>Server Based Systems</h3>
                            <p>
                                Initial developer and architecture designer of
                                the Wave Framework.
                            </p>
                        </div>
                        <div>
                            <h3>Gaming Systems</h3>
                            <p>
                                Consumer of the configuration of gaming servers
                                and specifier of those same configurations.
                            </p>
                            <h3>Operative Systems</h3>
                            <p>
                                API provider for remote execution commands on
                                the machine with the role of gaming server.
                            </p>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
}
